import React, { forwardRef } from "react";
import styles from "./phoneinput.module.scss";
import { loadPhoneInputConfiguration } from "./phoneInputConfig";

interface Props {
  id?: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placelhoder?: string;
  value?: string;
  onSelectChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  selectName?: string;
  selectValue?: string;
  disabled?: boolean;
}

const PhoneInput = forwardRef<HTMLSelectElement, Props>((props, ref) => {
  const { id, name, onChange, placelhoder, value, onSelectChange, selectValue, selectName, disabled } = props;
  const prefixs = loadPhoneInputConfiguration();

  // render
  return (
    <div className="input-group">
      <div className="input-group-prepend">
        <div className="input-group-text bg-white p-0 border-0">
          <select
            ref={ref}
            className={`custom-select ${styles.select}`}
            name={selectName}
            onChange={onSelectChange}
            value={selectValue}
            disabled={disabled}
          >
            {prefixs.map((item) => (
              <option value={item.prefix} key={item.prefix}>
                {item.prefix}
              </option>
            ))}
          </select>
        </div>
      </div>
      <input
        type="text"
        className="form-control"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placelhoder}
        disabled={disabled}
      />
    </div>
  );
});

export default PhoneInput;
